import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig } from '@spartacus/core';
import { OrderConfirmationComponent } from './order-confirmation.component';

@NgModule({
  declarations: [OrderConfirmationComponent],
  imports: [CommonModule, I18nModule, MatProgressSpinnerModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        OrderConfirmationDeliveryPaymentComponent: {
          component: OrderConfirmationComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
})
export class OrderConfirmationModule {}
